var map = {
	"./admin_settings.png": 1800,
	"./appraisals.png": 1801,
	"./catalog.png": 1802,
	"./catalogWhite.png": 1803,
	"./catalog_orders.png": 1804,
	"./cms.png": 1805,
	"./component-fields/Asset.png": 1806,
	"./component-fields/Blocks.png": 1807,
	"./component-fields/Boolean.png": 1808,
	"./component-fields/Date-time.png": 1809,
	"./component-fields/LInk.png": 1810,
	"./component-fields/Markdown.png": 1811,
	"./component-fields/Multi asset.png": 1812,
	"./component-fields/Multi options.png": 1813,
	"./component-fields/Number.png": 1814,
	"./component-fields/Richtext.png": 1815,
	"./component-fields/Single options.png": 1816,
	"./component-fields/Table.png": 1817,
	"./component-fields/Text area.png": 1818,
	"./component-fields/Text.png": 1819,
	"./components.png": 1820,
	"./configuration.png": 1821,
	"./contents.png": 1822,
	"./crm.png": 1823,
	"./custom_order.png": 1824,
	"./customer_credits.png": 1825,
	"./customer_list.png": 1826,
	"./dashboard.png": 1827,
	"./finance.png": 1828,
	"./home.png": 1829,
	"./integrations.png": 1830,
	"./inventory-transfers.png": 1831,
	"./invoice-list.png": 1832,
	"./layaway.png": 1833,
	"./move.png": 1834,
	"./new_sale.png": 1835,
	"./orders.png": 1836,
	"./outgoing-consignments.png": 1837,
	"./payment-methods/amex.png": 1195,
	"./payment-methods/discover.png": 1194,
	"./payment-methods/mastercard.png": 1193,
	"./payment-methods/visa.png": 1192,
	"./payments.png": 1838,
	"./plus.png": 1420,
	"./register.png": 1839,
	"./repair_center.png": 1840,
	"./reports.png": 1841,
	"./services.png": 1842,
	"./trade_in_center.png": 1843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1669;